import React, {useEffect, useState} from 'react'
import {useUserContext} from "../contexts/UserContext";
import Button from "react-bootstrap/Button";
import Box from "@mui/material/Box";
import {useMediaQuery} from "react-responsive";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

import useDidMountEffect from "../hooks/useDidMountEffect";
import Stack from "@mui/material/Stack";
import classnames from "classnames";
import {LocationItem} from "./LocationItem";
import {CreateLocationInput} from "./CreateLocationInput";
import {mediaQueryForMobile} from "../pages/HomePage/HomePage";
import CircularProgress from "@mui/joy/CircularProgress";
import {toast} from "react-toastify";
import {useFetchHook} from "../hooks/useFetchHook";
import fetcher from "../fetcher";
import Checkbox from "@mui/material/Checkbox";


export const LocationsTable = (props) => {
   const {
       initialLocation,
       selectLocation,
       onLocationCreate,
       isDealLocation,
       isSaving,
       isProfilePage
   } = props
    const [selectedLocation, setSelectedLocation] = useState(initialLocation)
    const [shouldSetCustomerLocation, setShouldSetCustomerLocation] = useState(true)
    const [shouldSetDealerLocation, setShouldSetDealerLocation] = useState(true)

    const { updateProfileResponse } = useUserContext()

    const [getLocationsResponse, getLocations] = useFetchHook(fetcher.getLocations)
    const [createLocationResponse, createLocation] = useFetchHook(fetcher.createLocation)
    const [updateLocationResponse, updateLocation] = useFetchHook(fetcher.updateLocation)
    const [deleteLocationResponse, deleteLocation] = useFetchHook(fetcher.deleteLocation)
    const [locations, setLocations] = useState([])

    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    useEffect(() => {
        getLocations()
    }, [])

    useDidMountEffect(() => {
        getLocations()
    }, [deleteLocationResponse, createLocationResponse, updateProfileResponse, updateLocationResponse])

    useEffect(() => {
        if (getLocationsResponse?.data?.data) {
            setLocations(getLocationsResponse.data.data || [])
        }
    }, [getLocationsResponse])

    const onSaveLocation = (locationData) => {
        createLocation(locationData).then((data) => {
            const newLocation = data?.data
            setSelectedLocation(newLocation)
            onLocationCreate && onLocationCreate(data)
            toast.success("Successfully added location.")
        })
    }

    return (
        <Box className={'LocationsTable'}>
            <Stack
                direction="column"
                justifyContent="space-between"
            >
                <div
                    className={'LocationsTable_header settings-header'}
                    style={{
                        padding: '20px',
                        color: "#666666",
                        // background: isProfilePage ? '' : 'rgb(249 250 251)',
                        borderRadius: '20px 20px  0 0',
                        marginBottom: '5px'
                    }}
                >
                    <LocationOnOutlinedIcon sx={{color: '#2267CE'}}/>
                    <div>Edit Location</div>
                </div>
                <Stack
                    direction={isTabletOrMobile ? 'column': 'row'}
                    justifyContent="space-between"
                    alignItems="start"
                    sx={{
                        padding: '0px 30px',
                    }}
                >
                    <Stack
                        direction="column"
                        justifyContent="space-between"
                        sx={{
                            margin: isTabletOrMobile ? "0 0 30px 0" : "0 30px 0 0",
                        }}
                    >
                        <label>Enter 5-digit zipcode</label>
                        <CreateLocationInput
                            isSaving={createLocationResponse?.loading}
                            onSave={onSaveLocation}
                        />
                    </Stack>
                    <Stack
                        direction="column"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {
                            isProfilePage && initialLocation &&
                            <div>
                                <label>{isDealLocation ? '' : 'Default '} Location</label>
                                <LocationItem
                                    key={initialLocation.id}
                                    location={initialLocation}
                                    isSelected={initialLocation.id === selectedLocation?.id}
                                    setSelectedLocation={setSelectedLocation}
                                    isInitialLocation={true}
                                    updateLocation={updateLocation}
                                />
                            </div>
                        }
                        <Stack
                            direction="column"
                            sx={{
                                maxHeight: '800px'
                            }}
                        >
                            <label>Saved Locations</label>
                            <div
                                style={{
                                    overflow: 'scroll',
                                    height: '300px',
                                    marginBottom: '20px'
                                }}
                            >
                                {
                                    locations.map((location) =>
                                        <LocationItem
                                            key={location.id}
                                            location={location}
                                            isSelected={location.id === selectedLocation?.id}
                                            setSelectedLocation={setSelectedLocation}
                                            deleteLocation={
                                                (location) => deleteLocation(location).then(() => {
                                                    toast.success(`Successfully deleted location.`)
                                                })
                                            }
                                            isInitialLocation={false}
                                            updateLocation={updateLocation}
                                        />
                                    )
                                }
                            </div>
                            {
                                isProfilePage &&
                                <Button
                                    className={classnames('CreateLocationInput_button', {
                                        disabled: false
                                    })}
                                    onClick={() => selectLocation(selectedLocation, true)}
                                    disabled={!selectedLocation}
                                >
                                    {
                                        isSaving ? <CircularProgress variant="soft" size={'sm'}/> : 'Set Default Location'
                                    }
                                </Button>
                            }
                        </Stack>
                    </Stack>
                </Stack>
                {
                    !isProfilePage &&
                    <Stack
                        direction={isTabletOrMobile ? 'column' : 'row'}
                        alignItems={'center'}
                        justifyContent={'end'}
                        sx={{
                            // background: 'rgb(249 250 251)',
                            padding: '20px',
                            borderRadius: '0 0 20px 20px'
                        }}
                    >
                        <span>Customer</span>
                        <Checkbox
                            className={'payment-row_value'}
                            onChange={(value) => setShouldSetCustomerLocation(!shouldSetCustomerLocation)}
                            checked={shouldSetCustomerLocation}
                            disabled={false}
                        />
                        <span>Dealer</span>
                        <Checkbox
                            className={'payment-row_value'}
                            onChange={(value) => setShouldSetDealerLocation(!shouldSetDealerLocation)}
                            checked={shouldSetDealerLocation}
                            disabled={false}
                        />
                        <Button
                            className={classnames('', {
                                disabled: false
                            })}
                            onClick={() => selectLocation(selectedLocation, shouldSetCustomerLocation, shouldSetDealerLocation)}
                            disabled={!selectedLocation || !(shouldSetDealerLocation || shouldSetCustomerLocation)}
                        >
                            {
                                isSaving ? <CircularProgress variant="soft" size={'sm'}/> : `Set Location${shouldSetCustomerLocation && shouldSetDealerLocation ? 's': ''}`
                            }
                        </Button>
                    </Stack>
                }
            </Stack>
        </Box>
    )
}
